import React, { useEffect, useState } from "react";
import { observer } from "mobx-react";
import { withStyles } from "@material-ui/styles";
import { toJS } from "mobx";
import { withAlert } from "react-alert";
import tableIcons from "../../components/TableIcon";
import MaterialTable from "material-table";
import { useAlert } from "react-alert";
import krLoacale from "date-fns/locale/ko";
import Layout from "../../components/Layout";
import store from "../../stores/logininfoStore";
import { Typography } from "@material-ui/core";
import VisibilityIcon from "@material-ui/icons/Visibility";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";

// function logininfo() {
//   return observer(() => {
//     return (
//       <Layout>
//         <h2>logininfo</h2>
//       </Layout>
//     );
//   });
// }

const HiddenText = ({ content }) => {
  const [state, setState] = useState({ visible: false });

  const handleClcik = () => {
    setState(old => ({ ...old, visible: !old.visible }));
  };

  return (
    <span style={{ display: "inline-block" }}>
      <Typography>{state.visible ? content : "********"}</Typography>
      {state.visible ? (
        <VisibilityIcon style={{ cursor: "pointer" }} onClick={handleClcik} />
      ) : (
        <VisibilityOffIcon
          style={{ cursor: "pointer" }}
          onClick={handleClcik}
        />
      )}
    </span>
  );
};

const loginCol = [
  {
    title: "기관명",
    field: "locname",
    cellStyle: {
      textAlign: "center"
    }
  },
  {
    title: "비고",
    field: "bigo",
    cellStyle: {
      textAlign: "center"
    }
  },
  {
    title: "ID",
    field: "userid",
    cellStyle: {
      textAlign: "center"
    }
  },
  {
    title: "PW",
    field: "userpw",
    cellStyle: {
      textAlign: "center"
    },
    render: rowData => {
      return <HiddenText content={rowData.userpw} />;
    }
  }
];

const Logininfo = observer(() => {
  const { list } = toJS(store);
  const alert = useAlert();

  useEffect(() => {
    async function getList() {
      await store.getList();
    }
    getList();
  }, []);
  return (
    <Layout>
      <MaterialTable
        title="로그인 정보"
        icons={tableIcons}
        data={list}
        columns={[
          {
            title: "기관명",
            field: "locname",
            cellStyle: {
              textAlign: "center"
            }
          },
          {
            title: "비고",
            field: "bigo",
            cellStyle: {
              textAlign: "center"
            }
          },
          {
            title: "ID",
            field: "userid",
            cellStyle: {
              textAlign: "center"
            }
          },
          {
            title: "PW",
            field: "userpw",
            cellStyle: {
              textAlign: "center"
            },
            render: rowData => {
              return <HiddenText content={rowData.userpw} />;
            }
          }
        ]}
        localization={{
          header: {
            actions: "수정"
          },
          toolbar: {
            exportTitle: "내보내기",
            exportAriaLabel: "라벨",
            searchPlaceholder: "검색",
            searchTooltip: "검색",
            exportName: "엑셀로 내보내기",
            exportCSVName: "엑셀로 내보내기"
          },
          body: {
            editRow: {
              deleteText: "복구는 불가능 합니다. 삭제하시겠습니까?"
            },
            editTooltip: "수정",
            deleteTooltip: "삭제",
            addTooltip: "추가",
            dateTimePickerLocalization: krLoacale
          }
        }}
        options={{
          sorting: true,
          pageSize: 10,
          pageSizeOptions: [10, 15, 20, 30],
          addRowPosition: "first",

          padding: "dense",
          headerStyle: {
            textAlign: "center"
          },
          rowStyle: {
            height: "20px"
          }
        }}
        editable={{
          onRowUpdate: (newData, oldData) =>
            new Promise(resolve => {
              (async () => {
                try {
                  await store.updateInfo(newData);
                  resolve();
                } catch (e) {
                  alert.show(e.message);
                  resolve();
                }
              })();
            }),
          onRowAdd: (newData, oldData) =>
            new Promise(resolve => {
              (async () => {
                try {
                  await store.addInfo(newData);
                  resolve();
                } catch (e) {
                  alert.show(e.message);
                  resolve();
                }
              })();
            }),
          onRowDelete: (newData, oldData) =>
            new Promise(resolve => {
              (async () => {
                try {
                  await store.deleteInfo(newData);
                  resolve();
                } catch (e) {
                  alert.show(e.message);
                  resolve();
                }
              })();
            })
        }}
      />
    </Layout>
  );
});

export default Logininfo;
